"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Context = require("./Context");

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TypeaheadInput = function TypeaheadInput(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_Context.InputContext.Consumer, null, function (context) {
    var _cx;

    var activeIndex = context.activeIndex,
        id = context.id,
        inputProps = context.inputProps,
        isFocused = context.isFocused,
        isMenuShown = context.isMenuShown,
        labelKey = context.labelKey,
        multiple = context.multiple,
        onFocus = context.onFocus,
        onRemove = context.onRemove,
        placeholder = context.placeholder,
        selected = context.selected,
        otherProps = _objectWithoutProperties(context, ["activeIndex", "id", "inputProps", "isFocused", "isMenuShown", "labelKey", "multiple", "onFocus", "onRemove", "placeholder", "selected"]); // Add a11y-related props.


    var props = _objectSpread({}, inputProps, otherProps, {
      'aria-activedescendant': activeIndex >= 0 ? (0, _utils.getMenuItemId)(id, activeIndex) : '',
      'aria-autocomplete': multiple ? 'list' : 'both',
      'aria-expanded': isMenuShown,
      'aria-haspopup': 'listbox',
      'aria-owns': isMenuShown ? id : '',
      autoComplete: inputProps.autoComplete || 'off',
      // Re-open the menu, eg: if it's closed via ESC.
      onClick: onFocus,
      onFocus: onFocus,
      placeholder: selected.length ? null : placeholder,
      // Comboboxes are single-select by definition:
      // https://www.w3.org/TR/wai-aria-practices-1.1/#combobox
      role: 'combobox',
      type: inputProps.type || 'text'
    });

    var className = props.className || '';

    if (multiple) {
      props = _objectSpread({}, props, {
        'aria-expanded': undefined,
        inputClassName: className,
        labelKey: labelKey,
        onRemove: onRemove,
        role: undefined,
        selected: selected
      });
    }

    props.className = (0, _classnames.default)((_cx = {}, _defineProperty(_cx, className, !multiple), _defineProperty(_cx, "focus", isFocused), _cx));
    return children(props);
  });
};

var _default = TypeaheadInput;
exports.default = _default;